import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "tab-underline__header" }

import { toRefs } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'TabsUnderline',
  props: {
  tabText: {
    type: String,
    required: true
  },
  tabIcon: {
    type: Object,
    required: false,
    default: () => undefined
  },
  amount: {
    type: [Number, String],
    default: 0
  }
},
  emits: ['toggleActiveTab'],
  setup(__props, { emit: __emit }) {

const props = __props
const { tabText, amount } = toRefs(props)
const emits = __emit

function toggleActiveTab(e, tabTitle: string) {
  emits('toggleActiveTab', tabTitle)
  if (e) e.currentTarget.toggleAttribute('active')
  e.currentTarget.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'end' })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: "tab-underline",
    onClick: _cache[0] || (_cache[0] = (e) => toggleActiveTab(e, _unref(tabText)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(), _createBlock(_resolveDynamicComponent(__props.tabIcon))),
      _createTextVNode(" " + _toDisplayString(_unref(tabText)) + " (" + _toDisplayString(_unref(amount)) + ") ", 1)
    ])
  ]))
}
}

})